export const SUPPORT_EMAIL = "support@climatepartner.com";
